import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  BookOpen,
  Key,
  ArrowsLeftRight,
  CurrencyCircleDollar,
  Wallet,
  XCircle,
  ArrowRight 
} from '@phosphor-icons/react';
import { PUBLIC_ROUTES } from '../../constants/routes';
import { isOnDocsSubdomain } from '../../utils/navigation';
import './ApiSidebar.css';

/**
 * ApiSidebar Component
 * Vertical navigation sidebar for API Documentation pages
 * Includes icons, text, and arrow indicators
 * Uses clean URLs on docs subdomain, full paths on main site
 */
const ApiSidebar = () => {
  const location = useLocation();
  const isOnDocs = isOnDocsSubdomain();

  // Use clean routes on docs subdomain, full routes on main site
  const getRoute = (fullRoute) => {
    if (isOnDocs) {
      // Remove /api-docs prefix for clean URLs
      return fullRoute.replace('/api-docs', '') || '/';
    }
    return fullRoute;
  };

  const navItems = [
    { 
      path: getRoute(PUBLIC_ROUTES.API_DOCS_OVERVIEW), 
      label: 'Overview', 
      icon: BookOpen 
    },
    { 
      path: getRoute(PUBLIC_ROUTES.API_DOCS_AUTH), 
      label: 'Authentication', 
      icon: Key 
    },
    { 
      path: getRoute(PUBLIC_ROUTES.API_DOCS_SPLITS), 
      label: 'Splits', 
      icon: ArrowsLeftRight 
    },
    { 
      path: getRoute(PUBLIC_ROUTES.API_DOCS_TRANSACTIONS), 
      label: 'Transactions', 
      icon: Wallet 
    },
    { 
      path: getRoute(PUBLIC_ROUTES.API_DOCS_WALLETS), 
      label: 'Wallets', 
      icon: CurrencyCircleDollar 
    },
    { 
      path: getRoute(PUBLIC_ROUTES.API_DOCS_ERRORS), 
      label: 'Error Codes', 
      icon: XCircle 
    },
  ];

  const isActive = (path, exact = false) => {
    // Normalize paths for comparison (handle both clean and full routes)
    const currentPath = location.pathname;
    const normalizedPath = isOnDocs ? currentPath.replace('/api-docs', '') || '/' : currentPath;
    const normalizedItemPath = isOnDocs ? path.replace('/api-docs', '') || '/' : path;
    
    if (exact) {
      return normalizedPath === normalizedItemPath;
    }
    return normalizedPath.startsWith(normalizedItemPath);
  };

  return (
    <nav className="api-sidebar">
      <ul className="api-sidebar-list">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path, item.exact);
          return (
            <li key={item.path}>
              <Link
                to={item.path}
                className={`api-sidebar-link ${active ? 'active' : ''}`}
              >
                <Icon weight={active ? 'fill' : 'regular'} size={20} className="api-sidebar-icon" />
                <span className="api-sidebar-text">{item.label}</span>
                <ArrowRight weight="regular" size={16} className="api-sidebar-arrow" />
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default ApiSidebar;
